module.exports = __webpack_public_path__ + "img/26.520ba355.png";